import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
//import PoshPolicy from '../views/PoshPolicy.vue';

Vue.use(Vuex)
 //const URL = "http://localhost:8080/website";
 //const URL = "https://uat.apdclrms.com/website";
  //  const URL = "https://www.apdcl.org/website";
   const URL = window.location.origin+"/website";

const moduleContact = {
  state: {
    KeyOfficial: [],
    ZoneContact: [],
    CircleContact: [],
    DivisionContact: [],
    SubDivContact: [],
    IRCAContact: [],
    TCContact: [],
    JobResponsibility: [],
    BoardDirector: [],
    AgmContact:[]
  },
  mutations: {
    saveAllContact(state, value) {
      state.KeyOfficial = value.allContact.filter(function(obj) { return obj.type == 1; });
      state.ZoneContact = value.allContact.filter(function(obj) { return obj.type == 2; });
      state.CircleContact = value.allContact.filter(function(obj) { return obj.type == 3; });
      state.DivisionContact = value.allContact.filter(function(obj) { return obj.type == 4; });
      state.SubDivContact = value.allContact.filter(function(obj) { return obj.type == 5; });
      state.IRCAContact = value.allContact.filter(function(obj) { return obj.type == 6; });
      state.TCContact = value.allContact.filter(function(obj) { return obj.type == 7; });
      state.AgmContact = value.allContact.filter(function(obj) { return obj.type == 8; });
 
    },
    saveContactInfo(state, value) {
      state.KeyOfficial = value.keyOfficialContact;
      state.ZoneContact = value.zoneContact;
      state.CircleContact = value.circleContact;
      state.DivisionContact = value.divisionContact;
      state.SubDivContact = value.subDivisionContact;
      state.IRCAContact = value.ircaContact;
      state.TCContact = value.tcContact;
     
    },
    saveAboutContact(state, value) {
        var temp = [];
        var i=1;
        value.boardDirector.forEach(element => {
          var obj = {
              "desc" :  i+". "+element[1]+", "+ element[2]
              }
            i++;
            temp.push(obj);
        })
      state.BoardDirector = temp;
      state.JobResponsibility = value.jobResponsibility;
    }
  },
  actions: {
    retrieveAllContact(context, value) {
      axios.get(URL+ "/api/web/allContact").then(response => context.commit('saveAllContact', response.data))
    },
    retrieveContactInfo(context, value) {
      axios.get(URL+ "/api/web/contactInfo").then(response => context.commit('saveContactInfo', response.data))
    },
    retrieveAboutContact(context, value) {
      axios.get(URL+ "/api/web/aboutContact").then(response => context.commit('saveAboutContact', response.data))
    }
    },
  setters:{},
  getters:{
     getKeyOfficial: state => {
     return state.KeyOfficial;
   },
   getZoneData: state => {
    return state.ZoneContact;
  },
  getCircleContact: state => {
   return state.CircleContact;
 },
 getDivisionContact: state => {
  return state.DivisionContact;
},
getSubDivContact: state => {
 return state.SubDivContact;
},
getIRCAContact: state => {
 return state.IRCAContact;
},
getTCContact: state => {
 return state.TCContact;
},
getAgmContact: state => {
  return state.AgmContact;
 },
getJobResponsibility: state => {
 return state.JobResponsibility;
},
getBoardDirector: state => {
 return state.BoardDirector;
}
}
}

const moduleTender = {
state: {
    Tender: [],
  },
  mutations: {
    saveTender(state, value) {
      var temp = [];
      value.tenderList.forEach(element => {
      var style="";
      var dateString = element.bid_opening_date;
      var dateParts = dateString.split("/");
      var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      var bod = new Date(dateObject);
      var cd = new Date();
      var newImg="";
  //    console.log(bod + '<br>' + cd);
  /*    if (cd.getTime() > bod.getTime() )
          {
            style= "style='color:grey; pointer-events: none;'"
          }
      else
          {
            style= ""
          }
          */
      if(element.new_flag== "Y")
        newImg = "<img src='"+URL+"/assets/new.gif' />";


    if(element.file_location != null)
      {
        var doc_l = element.file_location.split("|")
        var doc_t = element.type.split("|")
        var date = element.date.split("|")
        var title = element.title.split("|")
        var new_flag = element.new_flag_doc.split("|")
        var desc = "<br>";
        var dated="";
        var newImgDoc=""

      for(var i=0; i<doc_l.length; i++)
      {
        if(doc_t[i] == 'Cancellation')
        break;
        if(date[i] != "NA")
          dated = "( Dated " + date[i] +")" ;

          if(new_flag[i] == "Y")
            newImgDoc = "<img src='"+URL+"/assets/new.gif' />" ;

        desc = desc  + "<span> <a " + style + " target='_blank' href='" + doc_l[i] +"'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' />" + doc_t[i]+ " : "+ title[i] + dated + "</a>"+newImgDoc+"<br></span>"
      }
    }
    else {
      desc="";
    }
        //console.log(desc);
      var obj = {
        "description" :  element.description
        + "<br><br><a " + style + " target='_blank' href='" + element.nit +"'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' />Notice Inviting Tender</a>"+newImg
        + desc,
        "tender_no" : "<span style='color: #424242; font-weight:600 '>" + element.tender_no + "</span>",
        "important_dates" : "<strong>Tender Date : </strong> " + element.tender_date + "<br><strong>Pre Bid Meeting Date : </strong> " + element.prebid_date + "<br><strong>Bid Submission Start Date : </strong> " + element.bid_start_date + "<br><strong>Bid Submission End Date : </strong>" + element.bid_end_date + "<br><strong>Bid Opening Date : </strong>" + element.bid_opening_date
        }
       temp.push(obj);
      })
      state.Tender = temp;
    }

  },
  actions: {
    retrieveTenderCurrent(context, value) {
      axios.get(URL+ "/api/tenderCurrent").then(response => context.commit('saveTender', response.data))
    },
    retrieveTenderPrevious(context, value) {
      axios.get(URL+ "/api/tenderPrevious").then(response => context.commit('saveTender', response.data))
    },
    retrieveTenderArchive(context, value) {
      axios.get(URL+ "/api/tenderArchive").then(response => context.commit('saveTender', response.data))
    },
    retrieveRdssTender(context, value) {
      axios.get(URL+ "/api/rdssProject").then(response => context.commit('saveTender', response.data))
    }
    },
  setters:{},
  getters:{
     getTender: state => {
     return state.Tender;
   }
}
}

const moduleDocument = {
  state: {
      Document: [],
      Notice: [],
      Form: [],
      ShutdownNotice : [],
      Report : [],
      Circular : [],
      OfficeOrder : [],
      Clarification :[],
      PressRelease :[],
      RTI:[],
      Tariff :[],
      News:[],
      NewsRoom:[],
      Marquee:[],
      Qsa:[],
      AnyDocument:[],
      BeeReport:[],
      AnnualReturn:[],
      AuditorsReport:[],
      DirectorsReport:[],
      PoshPolicy:[],
      Bld:[]
    },
  mutations: {
    saveDocument(state, value) {

      var temp = [];
      value.document.forEach(element => {
      var obj = {
         "name" : element.name,
         "path" : element.file_location
         }
       temp.push(obj);
      })
      state.Document = temp;
    },
    saveNotice(state, value) {
      var temp = [];

      value.document.forEach(element => {
      var obj = {
         "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
         "date" : element.date
         }
       temp.push(obj);
      })
      state.Notice = temp;
    },
    saveAuditorsReport(state, value) {
      var temp = [];

      value.document.forEach(element => {
      var obj = {
         "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
         "date" : element.date
         }
       temp.push(obj);
      })
      state.AuditorsReport = temp;
    },
    saveDirectorsReport(state, value) {
      var temp = [];

      value.document.forEach(element => {
      var obj = {
         "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
         "date" : element.date
         }
       temp.push(obj);
      })
      state.DirectorsReport = temp;
    },
    saveAnnualReturn(state, value) {
      var temp = [];

      value.document.forEach(element => {
      var obj = {
         "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
         "date" : element.date
         }
       temp.push(obj);
      })
      state.AnnualReturn = temp;
    },

    saveForm(state, value) {

      var temp = [];
      value.document.forEach(element => {
      var obj = {
         "name" : "<a href='"+URL +"/"+ element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
         "sub_type" : element.sub_type
         }
       temp.push(obj);
      })
      state.Form = temp;
    },

saveShutdownNotice(state, value) {
      var temp = [];
      console.log(value.document);
      value.document.forEach(element => {
      var obj = {
         "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
         "sub_type" : element.sub_type,
         "date" : element.date
         }
       temp.push(obj);
      })
      state.ShutdownNotice = temp;
    },

saveReport(state, value) {
      var temp = [];
      value.document.forEach(element => {
      var obj = {
         "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
         }
       temp.push(obj);
      })
      state.Report = temp;
    },
    saveCircular(state, value) {
      var temp = [];
      value.document.forEach(element => {
      var obj = {
         "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
         "date" : element.date
         }
       temp.push(obj);
      })
      state.Circular = temp;
    },
    saveOfficeOrder(state, value) {
      var temp = [];
      value.document.forEach(element => {
      var obj = {
         "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
          "date" : element.date
         }
       temp.push(obj);
      })
      state.OfficeOrder = temp;
    },
    saveClarification(state, value) {
      var temp = [];
      value.document.forEach(element => {
      var obj = {
         "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
          "date" : element.date
         }
       temp.push(obj);
      })
      state.Clarification = temp;
    },
    savePress(state, value) {
      var temp = [];
      value.document.forEach(element => {
      var obj = {
         "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
          "date" : element.date
         }
       temp.push(obj);
      })
      state.PressRelease = temp;
    },
    saveRTI(state, value) {
      var temp = [];
      value.document.forEach(element => {
      var obj = {
         "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
         }
       temp.push(obj);
      })
      state.RTI = temp;
    },
    saveTariff(state, value) {
      var temp = [];
      value.document.forEach(element => {
      var obj = {
         "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
         "sub_type" : element.sub_type
         }
       temp.push(obj);

      })
      state.Tariff = temp;
    },
    saveNewsRoom(state, value) {
      var temp = [];
      value.document.forEach(element => {
      var obj = {
         "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
         "sub_type" : element.sub_type
         }
       temp.push(obj);

      })
      state.NewsRoom = temp;
    },
    saveNews(state, value) {
      var temp = [];
      console.log(value.document)

      value.document.forEach(element => {
        var newImg="";
        if(element.new_flag == "Y")
        newImg = "<img src='https://www.apdcl.org/website/assets/new.gif'/>";

      var obj = {
         "type" : element.typeString,
         // "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
          "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'>" + element.name + "</a>"+newImg,
         }
       temp.push(obj);
      })
      state.News = temp;
    },
    saveMarquee(state, value) {
      var temp = [];
      console.log(value.document)
      value.document.forEach(element => {
        var newImg = "";
        var link=element[1];
        if(element[5]== "Y")
          newImg = "<img src='"+URL+"/assets/new.gif' />";
        if(element[2]!= "NA")
          link = "<a href='"+URL +"/" + element[2] +"'>" + element[1] + "</a>"
      var obj = {

              "title" : newImg + link,
         }
       temp.push(obj);
      })
      state.Marquee = temp;
    },
    saveQsa(state, value) {
          var temp = [];
          value.document.forEach(element => {
          var obj = {
            "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
            "subType": element.sub_type
            }
           temp.push(obj);
          })
          state.Qsa = temp;
        },
    saveAnyDocument(state, value) {
          var temp = [];
          value.document.forEach(element => {
          var obj = {
            "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
            "subType": element.sub_type
            }
           temp.push(obj);
          })
          state.AnyDocument = temp;
        },
    saveBeeReport(state, value) {
          var temp = [];
          value.document.forEach(element => {
          var obj = {
             "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
             }
           temp.push(obj);
          })
          state.BeeReport = temp;
        }, 
        saveBld(state, value) {
          var temp = [];
          value.document.forEach(element => {
          var obj = {
            "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
            "subType": element.sub_type
            }
           temp.push(obj);
          })
          state.Bld = temp;
        },
   savePoshPolicy(state, value) {
          var temp = [];
          value.document.forEach(element => {
          var obj = {
             "name" : "<a href='"+URL +"/" + element.file_location + "' target='_blank'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
             }
           temp.push(obj);
          })
          state.PoshPolicy = temp;
        }
  },
  actions: {
    retrieveDocument(context, value) {
      axios.get(URL+ "/api/web/document").then(response => context.commit('saveDocument', response.data))
    },
    retrieveNotice(context, value) {
      axios.get(URL+ "/api/web/notice").then(response => context.commit('saveNotice', response.data))
    },
    retrieveAuditorsReport(context, value) {
      axios.get(URL+ "/api/web/auditorsReport").then(response => context.commit('saveAuditorsReport', response.data))
    },
    retrieveDirectorsReport(context, value) {
      axios.get(URL+ "/api/web/directorsReport").then(response => context.commit('saveDirectorsReport', response.data))
    },
    retrieveAnnualReturn(context, value) {
      axios.get(URL+ "/api/web/annualReturn").then(response => context.commit('saveAnnualReturn', response.data))
    },
    retrieveForm(context, value) {
      axios.get(URL+ "/api/web/form").then(response => context.commit('saveForm', response.data))
    },
    retrieveShutdownNotice(context, value) {
      axios.get(URL+ "/api/web/shutdownNotice").then(response => context.commit('saveShutdownNotice', response.data))
    },
    retrieveReport(context, value) {
      axios.get(URL+ "/api/web/report").then(response => context.commit('saveReport', response.data))
    },
    retrieveCircular(context, value) {
      axios.get(URL+ "/api/web/circular").then(response => context.commit('saveCircular', response.data))
    },
    retrieveOfficeOrder(context, value) {
      axios.get(URL+ "/api/web/officeOrder").then(response => context.commit('saveOfficeOrder', response.data))
    },
    retrieveClarification(context, value) {
      axios.get(URL+ "/api/web/clarification").then(response => context.commit('saveClarification', response.data))
    },
    retrievePress(context, value) {
      axios.get(URL+ "/api/web/pressRelease").then(response => context.commit('savePress', response.data))
    },
    retrieveRTI(context, value) {
      axios.get(URL+ "/api/web/RTI").then(response => context.commit('saveRTI', response.data))
    },
    retrieveTariff(context, value) {
      axios.get(URL+ "/api/web/tariff").then(response => context.commit('saveTariff', response.data))
    },
    retrieveNews(context, value) {
      axios.get(URL+ "/api/web/news").then(response => context.commit('saveNews', response.data))
    },
    retrieveNewsRoom(context, value) {
      axios.get(URL+ "/api/web/newsroom").then(response => context.commit('saveNewsRoom', response.data))
    },
    retrieveMarquee(context, value) {
      axios.get(URL+ "/api/web/marquee").then(response => context.commit('saveMarquee', response.data))
    },
    retrieveQsa(context, value) {
      axios.get(URL+ "/api/web/qsa").then(response => context.commit('saveQsa', response.data))
    },
    retrieveAnyDocument(context, value) {
      axios.get(URL+ "/api/web/document").then(response => context.commit('saveAnyDocument', response.data))
    },
    retrieveBeeReport(context, value) {
      axios.get(URL+ "/api/web/beeReport").then(response => context.commit('saveBeeReport', response.data))
    },
    retrieveBld(context, value) {
      axios.get(URL+ "/api/web/bld").then(response => context.commit('saveBld', response.data))
    },
    retrievePoshPolicy(context, value) {
      axios.get(URL+ "/api/web/poshPolicy").then(response => context.commit('savePoshPolicy', response.data))
    }
    },
  setters:{},
  getters:{
     getDocument: state => {
     return state.Document;
   },
   getNotice: state => {
   return state.Notice;
 },
 getAnnualReturn: state => {
  return state.AnnualReturn;
 },
 getAuditorReport: state =>{
  return state.AuditorsReport;
 },
 getDirectorsReport: state =>{
  return state.DirectorsReport;
 },
 getForm: state => {
 return state.Form;
},
getShutdownNotice: state => {
return state.ShutdownNotice;
},
getReport: state => {
return state.Report;
},
getCircular: state => {
return state.Circular;
},
getOfficeOrder: state => {
return state.OfficeOrder;
},
getClarification: state => {
return state.Clarification;
},
getPress: state => {
return state.PressRelease;
},
getRTI: state => {
return state.RTI;
},
getTariff: state => {
return state.Tariff;
},
getNews: state => {
return state.News;
},
getNewsRoom: state => {
return state.NewsRoom;
},
getMarquee: state => {
return state.Marquee;
},
getQsa: state => {
return state.Qsa;
},
getAnyDocument: state => {
  return state.AnyDocument;
  },
getBeeReport: state => {
  return state.BeeReport;
  },
getPoshPolicy: state => {
    return state.PoshPolicy;
    },
getBld: state => {
    return state.Bld;
    }
}
}

const moduleCareer = {
  state: {
    Career: []
  },
  mutations: {
    saveCareer(state, value) {
      var temp = [];
      console.log(value.career)
      value.career.forEach(element => {
        var newImg = "";
        if(element.new_flag== "Y")
          newImg = "<img src='"+URL+"/assets/new.gif' />";

    if(element.file_location != null)
    {
      var doc_l = element.file_location.split("|")
      var doc_t = element.doc_type.split("|")
      var date = element.date.split("|")
      var title = element.title.split("|")
      var new_flag = element.new_flag_doc.split("|")
      var desc = "<br>";
      var dated="";
      var newImgDoc=""
      for(var i=0; i<doc_l.length; i++)
      {
        if(date[i] != "NA")
          dated = "( Dated " + date[i] +")" ;
          if(new_flag[i] == "Y")
            newImgDoc = "<img src='"+URL+"/assets/new.gif' />" ;
        desc = desc  + "<span> <a target='_blank' href='" + doc_l[i] +"'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' />" + doc_t[i] +" : "+ title[i] + dated + " </a>"+newImgDoc+"<br></span>"
      }
    }
    else
      desc = "";

    var adv ="";
    if(element.adv != "NA")
      {
        var adv =  "<br><a  target='_blank' href='"+URL +"/" + element.adv +"'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' />Employment Notice (Dated "+element.adv_date+") </a>"+newImg
      }
    else {
        adv ="";
      }
      //console.log(desc);
      var obj = {
        "description" :  "<strong>"+element.description+"</strong>"

        +adv
        + desc,
        "apply_link" : (element.apply_link != null) ? "<a target='_blank' class='btn btn-info btn-sm' href='"+URL +"/" + element.apply_link + ">Apply Here</a>" :"",
        "date" : element.adv_date
        }
       temp.push(obj);
      })
    state.Career = temp;
    }
  },
  actions: {
    retrieveCareer(context, value) {
      axios.get(URL+ "/api/web/career").then(response => context.commit('saveCareer', response.data))
    }
    },
  setters:{},
  getters:{
     getCareer: state => {
     return state.Career;
   }
}
}

export default new Vuex.Store({
modules: {
  moduleContact,
  moduleTender,
  moduleDocument,
  moduleCareer
  }
})
